import { useCallback } from 'react'
import { useQuery } from 'react-query'
import { Vehicle } from '../data/vehicle'

type VehicleId = string

const fetchVehicles = async () => {
  const url = `api/vehicles/models`

  return fetch(url).then(response => {
    if (!response.ok) {
      throw new Error('Something went wrong when fetching for vehicles')
    }

    return response.json()
  })
}

const vehiclesDataTransformation = (vehicles: Vehicle[]) => {
  return vehicles.sort((a, b) => (a.Brand + a.Model + a.Version > b.Brand + b.Model + b.Version ? 1 : -1))
}

export const useVehiclesQuery = () =>
  useQuery(['vehicle-models'], () => fetchVehicles(), {
    select: useCallback((response: any) => vehiclesDataTransformation(response.data), [])
  })

const fetchVehicleById = async (vehicleId: VehicleId | undefined) => {
  if (typeof vehicleId === 'undefined') throw new Error('Unable to find vehicle')

  const url = `api/vehicles/models/${vehicleId}`

  return fetch(url).then(response => {
    if (!response.ok) {
      throw new Error('Something went wrong when fetching details for vehicle: ' + vehicleId)
    }

    return response.json()
  })
}

export const useVehicleByIdQuery = (vehicleId: VehicleId | undefined, refetch: boolean | undefined) =>
  useQuery(['vehicle-model', vehicleId], () => fetchVehicleById(vehicleId), {
    enabled: Boolean(vehicleId) && Boolean(refetch)
  })

const fetchChargingSessionSimulation = async (vehicleId: string | undefined, queryParams?: string) => {
  if (typeof vehicleId === 'undefined') throw new Error('Unable to find vehicle')

  const url = `api/vehicles/models/${vehicleId}/simulation?`

  return fetch(url + queryParams, { method: 'GET' }).then(response => {
    if (!response.ok) throw new Error('Something went wrong when fetching for vehicles')

    return response.json()
  })
}

export const useChargingSimulationQuery = (vehicleId: VehicleId | undefined, queryParams?: string) =>
  useQuery(
    ['charging-simulation', vehicleId, queryParams],
    () => fetchChargingSessionSimulation(vehicleId, queryParams),
    {
      enabled: Boolean(vehicleId) && Boolean(queryParams)
    }
  )
